import script from "./TheSideBarItemWithChild.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSideBarItemWithChild.vue?vue&type=script&setup=true&lang=js"

import "./TheSideBarItemWithChild.vue?vue&type=style&index=0&id=f0c4f098&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0c4f098"]])

export default __exports__